import { useState, useEffect } from "react";

const NAV_LINKS = ["Home", "Services", "About", "Contact"];
const APK_LINK = "#"; 

const RECHARGE_SERVICES = [
  { icon: "📱", label: "Mobile Prepaid", color: "#3b82f6" },
  { icon: "🔄", label: "Mobile Postpaid", color: "#6366f1" },
  { icon: "📡", label: "DTH Recharge", color: "#10b981" },
  { icon: "📶", label: "Data Card", color: "#06b6d4" },
  { icon: "🌐", label: "Broadband", color: "#8b5cf6" },
  { icon: "🚗", label: "FASTag", color: "#f59e0b" },
];

const BILL_SERVICES = [
  { icon: "💡", label: "Electricity", color: "#f59e0b" },
  { icon: "🔥", label: "Gas Bill", color: "#ef4444" },
  { icon: "💧", label: "Water Bill", color: "#06b6d4" },
  { icon: "🏥", label: "Insurance", color: "#ec4899" },
  { icon: "📚", label: "Education", color: "#3b82f6" },
  { icon: "🏦", label: "Loan EMI", color: "#f97316" },
  { icon: "🏛️", label: "Municipal", color: "#84cc16" },
  { icon: "🎟️", label: "Challan", color: "#fb923c" },
];

function ServiceIcon({ icon, label, color }) {
  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center", gap: "10px",
      padding: "15px 5px", borderRadius: "16px", background: "rgba(255,255,255,0.02)",
      border: "1px solid rgba(255,255,255,0.05)", transition: "0.3s", cursor: "pointer"
    }}>
      <div style={{ fontSize: "24px", width: "50px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "12px", background: `${color}15`, color: color }}>
        {icon}
      </div>
      <span style={{ fontSize: "11px", fontWeight: "600", color: "#94a3b8", textAlign: "center" }}>{label}</span>
    </div>
  );
}

export default function HomeWebsite() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div style={{ 
      fontFamily: "'Rajdhani', sans-serif", background: "#020617", color: "#f1f5f9", 
      minHeight: "100vh", width: "100%", margin: 0, padding: 0, overflowX: "hidden" 
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@500;700&family=Orbitron:wght@900&display=swap');
        * { box-sizing: border-box; -webkit-tap-highlight-color: transparent; }
        body { margin: 0; padding: 0; }
        .grid-container { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 30px; width: 100%; }
        .services-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); gap: 15px; }
        @media (max-width: 768px) {
          .mobile-hide { display: none !important; }
          .hero-text { text-align: center; }
          .hero-btns { justify-content: center; }
        }
      `}</style>

      {/* NAVIGATION */}
      <nav style={{
        position: "fixed", top: 0, width: "100%", zIndex: 1000, 
        padding: scrolled ? "15px 5%" : "25px 5%",
        background: scrolled ? "rgba(2, 6, 23, 0.95)" : "transparent",
        backdropFilter: "blur(10px)", transition: "0.4s",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        borderBottom: scrolled ? "1px solid rgba(59,130,246,0.2)" : "none"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div style={{ width: "35px", height: "35px", borderRadius: "8px", background: "#3b82f6", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "900" }}>⚡</div>
          <span style={{ fontFamily: "'Orbitron'", fontSize: "1.2rem", letterSpacing: "1px" }}>AK<span style={{ color: "#3b82f6" }}>.</span>PRO</span>
        </div>

        <div className="mobile-hide" style={{ display: "flex", gap: "30px" }}>
          {NAV_LINKS.map(link => (
            <a key={link} href={`#${link.toLowerCase()}`} style={{ textDecoration: "none", color: "#94a3b8", fontWeight: "600", fontSize: "14px" }}>{link}</a>
          ))}
        </div>

        <button style={{ 
          padding: "10px 20px", borderRadius: "10px", border: "none", 
          background: "linear-gradient(135deg, #3b82f6, #1e40af)", color: "#fff", 
          fontWeight: "700", cursor: "pointer", fontSize: "13px" 
        }}>LOGIN</button>
      </nav>

      {/* HERO SECTION */}
      <section id="home" style={{ 
        width: "100%", minHeight: "100vh", display: "flex", alignItems: "center", 
        padding: "120px 6% 60px", background: "radial-gradient(circle at top right, rgba(59,130,246,0.1), transparent)" 
      }}>
        <div className="grid-container" style={{ alignItems: "center" }}>
          <div className="hero-text">
            <h1 style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)", fontFamily: "'Orbitron'", lineHeight: 1.1, marginBottom: "20px" }}>
              FAST <span style={{ color: "#3b82f6" }}>DIGITAL</span><br />PAYMENTS
            </h1>
            <p style={{ color: "#94a3b8", fontSize: "1.1rem", lineHeight: 1.6, marginBottom: "35px", maxWidth: "500px", marginInline: "auto 0" }}>
              Aligarh's leading portal for instant recharges and utility bills. Secure, encrypted, and available 24/7.
            </p>
            <div className="hero-btns" style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
              <button style={{ padding: "15px 30px", borderRadius: "12px", border: "none", background: "#3b82f6", color: "#fff", fontWeight: "700", cursor: "pointer", flex: "1 1 180px", maxWidth: "240px" }}>START RECHARGE</button>
              <button style={{ padding: "15px 30px", borderRadius: "12px", border: "1px solid #3b82f6", background: "transparent", color: "#3b82f6", fontWeight: "700", cursor: "pointer", flex: "1 1 180px", maxWidth: "240px" }}>DOWNLOAD APK</button>
            </div>
          </div>

          <div style={{ background: "rgba(15,23,42,0.6)", padding: "30px", borderRadius: "24px", border: "1px solid rgba(59,130,246,0.2)", backdropFilter: "blur(5px)" }}>
            <h3 style={{ fontSize: "1.3rem", marginBottom: "20px", textAlign: "center" }}>Instant Portal</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              <input placeholder="Enter Mobile Number" style={{ width: "100%", padding: "14px", borderRadius: "10px", border: "1px solid rgba(255,255,255,0.1)", background: "#020617", color: "#fff", outline: "none" }} />
              <select style={{ width: "100%", padding: "14px", borderRadius: "10px", border: "1px solid rgba(255,255,255,0.1)", background: "#020617", color: "#fff", outline: "none" }}>
                <option>Select Service</option>
                <option>Prepaid Recharge</option>
                <option>Electricity Bill</option>
                <option>DTH Recharge</option>
              </select>
              <button style={{ padding: "14px", borderRadius: "10px", border: "none", background: "#10b981", color: "#fff", fontWeight: "700", cursor: "pointer" }}>CONTINUE →</button>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section id="services" style={{ width: "100%", padding: "80px 6%", background: "rgba(0,0,0,0.2)" }}>
        <h2 style={{ textAlign: "center", fontFamily: "'Orbitron'", marginBottom: "50px", fontSize: "2rem" }}>OUR <span style={{ color: "#3b82f6" }}>SERVICES</span></h2>
        
        <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
          <div>
            <h4 style={{ marginBottom: "20px", color: "#3b82f6", letterSpacing: "1px" }}>MOBILE & CONNECTIVITY</h4>
            <div className="services-grid">
              {RECHARGE_SERVICES.map(s => <ServiceIcon key={s.label} {...s} />)}
            </div>
          </div>

          <div>
            <h4 style={{ marginBottom: "20px", color: "#f59e0b", letterSpacing: "1px" }}>UTILITIES & BILLS</h4>
            <div className="services-grid">
              {BILL_SERVICES.map(s => <ServiceIcon key={s.label} {...s} />)}
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section id="about" style={{ width: "100%", padding: "80px 6%" }}>
        <div className="grid-container" style={{ alignItems: "center" }}>
          <div style={{ padding: "40px", background: "linear-gradient(135deg, #1e293b 0%, #020617 100%)", borderRadius: "24px", textAlign: "center" }}>
            <span style={{ fontSize: "60px" }}>🔒</span>
            <h3 style={{ marginTop: "20px" }}>Bank-Grade Security</h3>
            <p style={{ color: "#64748b", marginTop: "10px" }}>All transactions are secured with 256-bit encryption.</p>
          </div>
          <div>
            <h2 style={{ fontFamily: "'Orbitron'", marginBottom: "20px" }}>TRUSTED BY <span style={{ color: "#3b82f6" }}>MILLIONS</span></h2>
            <p style={{ color: "#94a3b8", lineHeight: "1.8" }}>
              AK Pro is more than just a recharge site. We are a complete financial ecosystem designed to provide seamless payment experiences for users across the region.
            </p>
            <ul style={{ listStyle: "none", padding: 0, marginTop: "20px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
              {["✓ 99.9% Uptime", "✓ Instant Support", "✓ Easy Refunds", "✓ Multi-Operator"].map(item => (
                <li key={item} style={{ color: "#10b981", fontWeight: "700", fontSize: "14px" }}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ width: "100%", padding: "40px 6%", borderTop: "1px solid rgba(255,255,255,0.05)", textAlign: "center" }}>
        <div style={{ marginBottom: "20px", opacity: 0.6 }}>
          <span style={{ fontFamily: "'Orbitron'", fontSize: "14px" }}>AK.PRO SOLUTIONS</span>
        </div>
        <div style={{ display: "flex", gap: "20px", justifyContent: "center", marginBottom: "20px", flexWrap: "wrap" }}>
          {["Privacy", "Terms", "Contact", "Support"].map(f => (
            <a key={f} href="#" style={{ color: "#475569", textDecoration: "none", fontSize: "12px" }}>{f}</a>
          ))}
        </div>
        <p style={{ color: "#475569", fontSize: "11px" }}>© 2026 AK PRO. ALL RIGHTS RESERVED.</p>
      </footer>
    </div>
  );
}